// extracted by mini-css-extract-plugin
export var mainMenuLabel = "website-map-module--mainMenuLabel--ba384";
export var menu = "website-map-module--menu--9a0e0";
export var submenulabel = "website-map-module--submenulabel--aeae9";
export var websiteMap = "website-map-module--websiteMap--67ff8";